import { useContext } from "react"
import { P } from "../../../../auth/permissions"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import BaseInputField from "../../../../components/elements/BaseInputField"
import BaseDivider from "../../../../components/elements/BaseDivider"
import BaseDocumentElement from "../../../../components/elements/BaseDocumentElement"
import BaseInputArea from "../../../../components/elements/BaseInputArea"
import { SidePanelContext } from "../../../../components/contexts/SidePanelContext"
import BaseSelection from "../../../../components/elements/BaseSelection"
import { CostCenterType } from "../../../Mitarbeiter/types/Types"
import { ObjectType } from "../../types/types"
import { Form } from "antd"
import BaseSection from "../../../../components/elements/BaseSection"
import { ReactComponent as FOLDER } from "../../../../assets/Folder.svg"
import { DocumentDataType } from "../../../../components/types"
import { KeyRound } from "lucide-react"
import { useAbility } from "../../../../components/contexts/AbilityContext"

type ObjectDetailPartRightType = {
    objectData: ObjectType
    setobjectData: (e: any) => void // TODO
    costCenterData: CostCenterType[] // TODO
    setfileToDelete: (e: string) => void
    setselectedS3Key: (e: string) => void
    documents: DocumentDataType[]
    handleDownload: (e: string, f: string) => void
}

export default function ObjectDetailPartRight(props: ObjectDetailPartRightType) {
    const ability = useAbility()
    const modalCon = useContext(ModalContext)
    const sidePanelCon = useContext(SidePanelContext)
    const obvFound = props.documents?.find((item) => item?.tags?.includes("Objektbetreuungsvertrag"))

    return (
        <BaseSection>
            <div className="flex flex-row w-full justify-end pb-2 gap-2">
                <KeyRound className="w-6 h-6 cursor-pointer" onClick={() => modalCon?.trigger(10)} />
                <FOLDER className="w-6 h-6 cursor-pointer" onClick={() => modalCon?.trigger(9)} />
            </div>
            <div className="flex flex-col 2xl:flex-row gap-2 2xl:gap-4 2xl:items-end">
                <BaseInputField
                    disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                    label={"Einheiten pro Eingang"}
                    type={"number"}
                    value={props.objectData.objectInfo?.unitperentrance}
                    onChange={(e: string) =>
                        props.setobjectData((prev: any) => ({
                            ...prev,
                            objectInfo: {
                                ...prev.objectInfo,
                                unitperentrance: Number(e),
                            },
                        }))
                    }
                />
                <BaseInputField
                    disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                    label={"Gesamt"}
                    type={"number"}
                    value={props.objectData.objectInfo?.amount}
                    onChange={(e: string) =>
                        props.setobjectData((prev: any) => ({
                            ...prev,
                            objectInfo: {
                                ...prev.objectInfo,
                                amount: Number(e),
                            },
                        }))
                    }
                />
                <BaseInputField
                    disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                    label={"Grundstücksfläche im m²"}
                    type={"number"}
                    value={props.objectData.objectInfo?.propertyArea}
                    onChange={(e: string) =>
                        props.setobjectData((prev: any) => ({
                            ...prev,
                            objectInfo: {
                                ...prev.objectInfo,
                                propertyArea: Number(e),
                            },
                        }))
                    }
                />
            </div>
            <BaseInputField
                disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                classProps="pt-2"
                label={"Vertragsbeginn"}
                type={"date"}
                value={props.objectData.objectInfo?.contractStart}
                onChange={(e: string) =>
                    props.setobjectData((prev: any) => ({
                        ...prev,
                        objectInfo: {
                            ...prev.objectInfo,
                            contractStart: e,
                        },
                    }))
                }
            />
            <BaseInputField
                disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                classProps="pt-2"
                label={"Vertragsende"}
                type={"date"}
                value={props.objectData.objectInfo?.contractEnd}
                onChange={(e: string) =>
                    props.setobjectData((prev: any) => ({
                        ...prev,
                        objectInfo: {
                            ...prev.objectInfo,
                            contractEnd: e,
                        },
                    }))
                }
            />
            <BaseInputField
                disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                classProps="pt-2"
                label={"Letzte Preisanpassung"}
                type={"date"}
                value={props.objectData.objectInfo?.lastPriceChange}
                onChange={(e: string) =>
                    props.setobjectData((prev: any) => ({
                        ...prev,
                        objectInfo: {
                            ...prev.objectInfo,
                            lastPriceChange: e,
                        },
                    }))
                }
            />
            <BaseInputField
                disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                classProps="pt-2"
                label={"Letzte Vertragsänderung"}
                type={"date"}
                value={props.objectData.objectInfo?.lastContractChange}
                onChange={(e: string) =>
                    props.setobjectData((prev: any) => ({
                        ...prev,
                        objectInfo: {
                            ...prev.objectInfo,
                            lastContractChange: e,
                        },
                    }))
                }
            />
            <Form.Item className="mb-2" name={"costcenter"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                <BaseSelection
                    disabled={!ability.can(P.niederlassungen_read_write.action, P.niederlassungen_read_write.subject)}
                    classProps="pt-2"
                    placeholder={""}
                    label={"Zugeordnet zu Niederlassung"}
                    value={props.costCenterData?.find((item) => item._id === props.objectData.costCenter)?.name ?? ""}
                    data={props.costCenterData?.map((item) => item.name)}
                    setId={(newItem: any) => {
                        let id = props.costCenterData?.find((item: { name: string }) => newItem === item.name)?._id
                        props.setobjectData((prev: any) => ({
                            ...prev,
                            costCenter: id,
                        }))
                    }}
                />
            </Form.Item>
            <BaseInputArea
                label={"Bemerkung"}
                classProps="pt-2"
                disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                value={props.objectData.objectInfo?.notes}
                onChange={(e: string) =>
                    props.setobjectData((prev: any) => ({
                        ...prev,
                        objectInfo: {
                            ...prev.objectInfo,
                            notes: e,
                        },
                    }))
                }
            />
            <BaseDivider classProps="mt-6 mb-2" />

            <Form.Item className="mb-2" name={"objectIndication"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                <BaseInputField
                    disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                    label={"Objektbezeichnung *"}
                    type={"text"}
                    value={props.objectData.objectIndication}
                    onChange={(e: string) =>
                        props.setobjectData((prev: any) => ({
                            ...prev,
                            objectIndication: e,
                        }))
                    }
                />
            </Form.Item>
            <div className="flex flex-row gap-4 pt-2">
                <Form.Item className="mb-2 w-2/3" name={"street"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField
                        disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                        label={"Straße *"}
                        type={"text"}
                        value={props.objectData.adress?.street}
                        onChange={(e: string) =>
                            props.setobjectData((prev: any) => ({
                                ...prev,
                                adress: {
                                    ...prev.adress,
                                    street: e,
                                },
                            }))
                        }
                    />
                </Form.Item>
                <Form.Item className="mb-2 w-1/3" name={"nr"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField
                        disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                        label={"Nummer *"}
                        type={"text"}
                        value={props.objectData.adress?.nr}
                        onChange={(e: string) =>
                            props.setobjectData((prev: any) => ({
                                ...prev,
                                adress: {
                                    ...prev.adress,
                                    nr: e,
                                },
                            }))
                        }
                    />
                </Form.Item>
            </div>
            <div className="flex flex-row gap-4 pt-2">
                <Form.Item className="mb-2 w-1/3" name={"plz"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField
                        disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                        label={"PLZ *"}
                        width="w-64"
                        type={"text"}
                        value={props.objectData.adress?.plz}
                        onChange={(e: string) =>
                            props.setobjectData((prev: any) => ({
                                ...prev,
                                adress: {
                                    ...prev.adress,
                                    plz: e,
                                },
                            }))
                        }
                    />
                </Form.Item>
                <Form.Item className="mb-2 w-2/3" name={"city"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField
                        disabled={!ability.can(P.objekte_read.action, P.objekte_read.subject)}
                        label={"Stadt *"}
                        type={"text"}
                        value={props.objectData.adress?.city}
                        onChange={(e: string) =>
                            props.setobjectData((prev: any) => ({
                                ...prev,
                                adress: {
                                    ...prev.adress,
                                    city: e,
                                },
                            }))
                        }
                    />
                </Form.Item>
            </div>
            {/* OBV Document */}
            {obvFound && (
                <>
                    <BaseDivider classProps="mt-6 mb-2" />
                    <div className="flex flex-col pt-2">
                        <label className="text-sm pl-2 pb-1">Vertrag zum Objekt</label>
                        <BaseDocumentElement
                            obv
                            title={obvFound.title}
                            permissions={[P.objekte_read_write]}
                            timestamp={obvFound.timestamp}
                            downloadFunc={() => props.handleDownload(obvFound.s3Key, obvFound.title)}
                            deleteFunc={() => {
                                props.setfileToDelete(obvFound.s3Key)
                                modalCon?.trigger(4)
                            }}
                            showPreviewFunc={() => {
                                props.setselectedS3Key(obvFound.s3Key)
                                sidePanelCon?.trigger(6)
                            }}
                        />
                    </div>
                    <BaseDivider classProps="mt-2 mb-2" />
                </>
            )}
        </BaseSection>
    )
}
